"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactColor = require("react-color");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const PickerDialog = _ref => {
  let {
    value,
    onClick,
    onChange
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    style: {
      position: 'relative'
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        position: 'absolute',
        zIndex: '2'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          position: 'fixed',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px'
        },
        onClick: onClick
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactColor.ChromePicker, {
        color: value,
        onChange: onChange
      })]
    })
  });
};
PickerDialog.propTypes = {
  value: _propTypes.default.string,
  onChange: _propTypes.default.func,
  onClick: _propTypes.default.func
};
var _default = exports.default = PickerDialog;